import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import SharedGPATabelConverter from "./SharedGPATabelConverter";
const TITLE = "Tabel Konversi IPK Universitas";
const DESCRIPTION =
  "Tabel Konversi IPK (GPA) - Konversikan antar sistem global (Amerika, Eropa, Arab) dengan mudah! Hitung nilai setara Anda untuk universitas luar negeri atau beasiswa dengan akurat.";
const KEYWORDS =
  "konversi IPK dari 4 ke 100, konversi IPK dari 5 ke 4, konversi IPK dari 100 ke 4, konversi IPK dari 4 ke 5, konversi IPK dari 4 ke 5";
const OG_URL = "https://do-calculate.com/calculator/id/gpatableconverter";
function GPATabelConverter() {
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <FirstAds />
      </div>
      <div className="row">
        <div className="col">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <SharedGPATabelConverter />
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <SecondAds />
        <br />
        <MainCalculatorsList></MainCalculatorsList>
        <br />
      </div>
      {" "}
      <br />
    </div>
  );
}
export default GPATabelConverter;